import { useNavigate } from 'react-router';
import { useT } from '@/i18n';
import { Empty, Ltr, QueryView, StatusPill } from '@/components/ui';
import { useOverview } from '@/lib/api/hooks';
import { shortDate, timecode } from '@/lib/format';

/** "Episode" nav entry: the latest episodes across projects; pick one to open its drill-down. */
export function EpisodesPage() {
  const { t, locale } = useT();
  const navigate = useNavigate();
  const overview = useOverview();
  return (
    <div className="page" style={{ maxWidth: 1100 }}>
      <div className="stack">
        <h1 className="h1">{t('episodes')}</h1>
        <span className="muted">{t('recentEpisodesSub')}</span>
      </div>
      <section className="card">
        <QueryView query={overview}>
          {(o) =>
            o.recent.length === 0 ? (
              <Empty>{t('noRecent')}</Empty>
            ) : (
              <>
                {o.recent.map((e) => (
                  <button key={e.id} type="button" className="clickable card-row" onClick={() => navigate(`/projects/${e.projectId}/episodes/${e.id}`)} style={{ display: 'grid', gridTemplateColumns: 'minmax(90px,160px) 44px minmax(0,1fr) 80px 80px auto', gap: 14, alignItems: 'center' }}>
                    <span className="muted small ellipsis">{e.projectTitle}</span>
                    <span className="mono small muted">{e.number}</span>
                    <span className="ellipsis" style={{ fontWeight: 500 }}>{e.title}</span>
                    <span className="muted small">{shortDate(locale, e.recordedAt)}</span>
                    <Ltr className="mono small muted">{e.durationMs ? timecode(e.durationMs) : '—'}</Ltr>
                    <StatusPill status={e.status} />
                  </button>
                ))}
              </>
            )
          }
        </QueryView>
      </section>
    </div>
  );
}
